import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ISplittedBlockTimeRecordViewModel } from 'src/app/ReusableComponent/block-time-report/block-time-report.model';
import { CustomerList } from 'src/app/service/customer.model';

@Injectable({
  providedIn: 'root'
})
export class SplitRecordDialogService {
  isValidToSplit: boolean = true;

  constructor(
    private _toaster: ToastrService
  ) { }

  isBlockTimeRecordApplicableToSplit(splittedBlockTimeRecordList: ISplittedBlockTimeRecordViewModel[],
    customer: CustomerList, isShowToasterMessage: boolean) {
    this.checkSplittedBlockTimeRecordLength(splittedBlockTimeRecordList);
    this.checkIfAllTheLegsAreFilltedOrNot(splittedBlockTimeRecordList, isShowToasterMessage);
    this.checkForSameCustomerToAllTheRecords(splittedBlockTimeRecordList, isShowToasterMessage);
    this.checkExistanceOfParentCustomer(splittedBlockTimeRecordList, customer, isShowToasterMessage);
  }

  checkSplittedBlockTimeRecordLength(splittedBlockTimeRecordList: ISplittedBlockTimeRecordViewModel[]) {
    this.isValidToSplit = splittedBlockTimeRecordList.length > 1 ;
  }
  checkIfAllTheLegsAreFilltedOrNot(splittedBlockTimeRecordList: ISplittedBlockTimeRecordViewModel[],
    isShowToasterMessage: boolean) {
    if(this.isValidToSplit) {
      const isValid = (splittedBlockTimeRecordList.every((record:ISplittedBlockTimeRecordViewModel) => {
        return record.customer.length != 0;
      }));
      this.isValidToSplit = isValid;
      if(!isValid && isShowToasterMessage) {
        this.warning("Please select customer for all the legs!");
      }
    }
  }
  checkForSameCustomerToAllTheRecords(splittedBlockTimeRecordList: ISplittedBlockTimeRecordViewModel[],
    isShowToasterMessage: boolean) {
    if(this.isValidToSplit) {
      const isValid = !(splittedBlockTimeRecordList.every((record:ISplittedBlockTimeRecordViewModel) => {
        return record.customer[0]?.customerID == splittedBlockTimeRecordList[0].customer[0].customerID;
      }));
      this.isValidToSplit = isValid;
      if(!isValid && isShowToasterMessage) {
        this.warning("Please select atleast one different customer to split the record!");
      }
    }
  }
  checkExistanceOfParentCustomer(splittedBlockTimeRecordList: ISplittedBlockTimeRecordViewModel[],
    customer: CustomerList, isShowToasterMessage: boolean) {
    if(this.isValidToSplit) {
      const isValid = splittedBlockTimeRecordList.some((record:ISplittedBlockTimeRecordViewModel) => {
        return record.customer[0].customerID == customer.customerID;
      });
      this.isValidToSplit = isValid;
      if(!isValid && isShowToasterMessage) {
        this.warning("Please select the parent customer for at least one leg to split the record!");
      }
    }
  }

  warning(message: string) {
    this._toaster.warning(message, "Warning", { timeOut: 6000, positionClass: "toast-top-center" });
  }
  success(message: string) {
    this._toaster.success(message, "Success", { timeOut: 6000, positionClass: "toast-top-center" });
  }
}
